<header>
	<div class="container">
		<a class="icon-novae" href="https://novae.io/#/home" target="_blank"><img src="./assets/images/icon-novae.svg" alt=""></a>
		<img src="../assets/images/myrewards-miles/logo-mr-sales.svg" alt="">
	</div>
</header>
